import { render } from "./StreamsManageDashboard.vue?vue&type=template&id=090c5c40"
import script from "./StreamsManageDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsManageDashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/StreamsDash/StreamsManageDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "090c5c40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('090c5c40', __exports__)) {
    api.reload('090c5c40', __exports__)
  }
  
  module.hot.accept("./StreamsManageDashboard.vue?vue&type=template&id=090c5c40", () => {
    api.rerender('090c5c40', render)
  })

}


export default __exports__